import Vue from "vue";
import router from "./router";
import App from "./App";
import Vuelidate from "vuelidate";
import Toasted from "vue-toasted";
import store from "@/store/";
import focus from "@/common/directives/focus";
// custom bootstrap
import "build-ui/dist/styles/build-ui.css";
// application wide css
import "./css/app.less";

Vue.config.productionTip = true;
if (process.env.NODE_ENV == "production") {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

Vue.use(Toasted);
Vue.use(Vuelidate);

new Vue({
  store,
  router,
  directives: {
    focus
  },
  render: h => h(App)
}).$mount("#app");
